import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Card, Row, Heading, Loading } from '../../core';
import {
  getCustomVaultName,
  useVaultPageSubgraph,
  useChain,
  useWeb3React,
  useScionVault,
} from '@sc1/common';
import { Stats } from '../../Stats';
import { ScionWithdraw } from './ScionWithdraw';
import { ScionDeposit } from './ScionDeposit';
import { VaultDescription } from '../VaultDescription';
import { RequireNetwork } from '../../RequireNetwork';

export const ScionVault = (): JSX.Element => {
  const { vaultAddress } = useParams();
  const { account } = useWeb3React();
  const chain = useChain();

  const { data, loading } = useVaultPageSubgraph();
  const { name } = data?.vault || {};
  const customName = useMemo(() => getCustomVaultName(name), [name]);

  const vault = useScionVault(vaultAddress);
  return (
    <Card>
      <Loading loading={loading}>
        <Heading as="h2">{customName}</Heading>
        <Stats data={data?.vault} chain={chain} />
      </Loading>

      <RequireNetwork>
        {vault && account && (
          <Row mt={7} variant="collapse">
            <ScionDeposit vault={vault} account={account} />
            <Box mx={4} my={3} />
            <ScionWithdraw vault={vault} account={account} />
          </Row>
        )}
      </RequireNetwork>
      <VaultDescription
        vaultName={customName}
        address={vaultAddress}
        chain={chain}
      />
    </Card>
  );
};
